import "./CustomDateTimeInput.scss";
import { showToastMessage } from "../../../utils/commonFunctions";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs'
import { useParams } from "react-router-dom";

interface CustomDateTimeInputProps {
    dateTime: number | null; // ISO 8601 format
    setDateTime: (dateTime: number | null) => void; // Function to update the dateTime
    type: string;
    range?: {
        start: number;
        end: number;
    }
}

const CustomDateTimeInput = ({ dateTime, setDateTime, type, range}: CustomDateTimeInputProps) => {
    const {dashboard} = useParams();

    const validateDateTime = (inputDate: number) => {
        const min = range?.start;
        const max = range?.end;
        const updatedType = type === 'startTime' ? 'Start time' : 'End time';
        if(dashboard !== 'operate'){
            if (!min || !max) return true;
            else if ((inputDate < min || inputDate > max)) {
                const minDateTime = dayjs.unix(min).utc().toISOString()
                const maxDateTime = dayjs.unix(max).utc().toISOString()
                showToastMessage('error', `${updatedType} must be between ${minDateTime} and ${maxDateTime}`);
                return false;
            }
            return true;
        }else {
            if (!min) return true;
            else if ((inputDate < min)) {
                const minDateTime = dayjs.unix(min).utc().toISOString()
                showToastMessage('error', `${updatedType} must be greater than ${minDateTime}`);
                return false;
            }
            return true;
        }
    }

    const handleChange = (value: any) => {
        if (!value || !dayjs(value).isValid()) { return setDateTime(null); }
        const epoch = dayjs.utc(value).unix();
        const validate = validateDateTime(epoch);
        if (validate) {
            setDateTime(epoch);
        }
    };

    return (
        <div className={`customDateTimeInputDiv ${type}`}>
            <LocalizationProvider adapterLocale={'en'} dateAdapter={AdapterDayjs}>
                <DateTimePicker
                    timezone="UTC"
                    sx={{
                        borderRadius: '0px',
                        width: 'auto',
                        flex: '1 1 0%',
                        '.MuiFormControl-root': {
                            paddingRight: '0px',
                        },
                        '.MuiInputBase-input': {
                            fontSize: '12px !important',
                            height: '24px !important',
                            padding: '0 4px',
                            '&::placeholder': {
                                fontSize: '12px !important',
                            },
                        },
                        '.MuiOutlinedInput-input': {
                            fontSize: '12px !important',
                            height: '24px !important',
                            flex: '1 1 0% !important',
                            padding: '0 !important',
                            width: '100% !important',
                            fontFamily: '"Montserrat", Roboto, sans-serif'
                        },
                        '.MuiOutlinedInput-root': {
                            minHeight: '24px !important',
                            height: '24px !important',
                            paddingRight: '0px',
                            width: '150px !important',
                            flex: '1 1 0% !important',
                        },
                        '.MuiInputAdornment-root': {
                            display: 'none',
                        },
                        '.MuiOutlinedInput-notchedOutline': {
                            borderRadius: '0px',
                            border: 'none',
                        },
                    }}
                    className="rounded-3"
                    ampm={false}
                    format='YYYY-MM-DD HH:mm:ss'
                    views={['year', 'month', 'day', 'hours', 'minutes', 'seconds']}
                    value={dateTime ? dayjs.utc(dateTime * 1000) : null}
                    onChange={handleChange}
                />
            </LocalizationProvider>
        </div>
    );
};
export default CustomDateTimeInput;